import { useEffect } from "react";
import { SplatViewer } from "./components/SplatViewer";
import { PerfHUD } from "./components/PerfHUD";
import { LoadingOverlay } from "./components/LoadingOverlay";
import { SceneControls } from "./components/SceneControls";
import { ScenePicker } from "./components/ScenePicker";
import { useViewerStore } from "./state/viewerStore";
import { defaultSceneUrl } from "./scenes";

export function App() {
  const setSceneUrl = useViewerStore((s) => s.setSceneUrl);

  useEffect(() => {
    setSceneUrl(defaultSceneUrl());
  }, [setSceneUrl]);

  return (
    <>
      <SplatViewer />
      <LoadingOverlay />
      <PerfHUD />
      <ScenePicker />
      <SceneControls />
    </>
  );
}
